export default __webpack_public_path__ + "static/Poster-e231f7b9a368ee8aecac8475e43bfbe9.jpg";